import React, { useRef, useState } from 'react'
import { lang } from 'utils/helpers'
import './styles.scss'
import { InputChipsWithSearch } from 'components/common'
import { Button } from 'components/Form'
import _debounce from 'lodash.debounce'
import { apiInchat } from 'api'

const FooterAddUser = ({ conversation, conversationAction, setErrorModal }) => {
  const [usersData, setUsersData] = useState({})
  const [selectedUsers, setSelectedUsers] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  const debouncedSearchUsers = useRef(
    _debounce(async text => {
      getData(text)
    }, 350)
  ).current

  const handleSelectedUsers = values => {
    setSelectedUsers(values)
    if (values.input.length >= 3) {
      debouncedSearchUsers(values.input)
    } else {
      setUsersData({})
    }
  }

  const getData = async (text) => {
    const { data } = await apiInchat.searchUsers({ text })
    setUsersData(data)
  }

  const handleAddUsers = () => {
    setErrorModal('')
    setIsSubmitting(true)
    const userIds = selectedUsers?.chips.map(user => user.id)
    conversationAction({
      type: 'invite',
      conversationId: conversation._id,
      conversationType: conversation.type,
      userIds
    }).then(() => {
      setUsersData({})
      setSelectedUsers({})
    }).catch(() => {
      setErrorModal(lang('dashboard_channel-users-not-added'))
    }).finally(() => setIsSubmitting(false))
  }
  return (
    <div className='inchat-add-user-container'>
      <label>{lang('dashboard_add-user')}</label>
      <div className='inchat-add-user-container__input-button'>
        <InputChipsWithSearch
          data={usersData.users?.map(user => ({
            id: user._id,
            avatar: user.picture,
            name: `${user.name} ${user.lastname}`
          }))}
          placeholder={lang('dashboard_add-user')}
          values={selectedUsers}
          onChange={handleSelectedUsers}
          customClassName
        />

        <Button
          className='inchat-add-user-container__input-button--button'
          secondary
          value={lang('dashboard_add-user')}
          onClick={handleAddUsers}
          isSubmitting={isSubmitting}
          disabled={ selectedUsers?.chips?.length > 0 ? false : true}
        />

      </div>
    </div>
  )
}

export default FooterAddUser